/* gc-google-reviews.js (Skippy, Oct 24 2026) - live Google reviews on boutique pages.
   Loads the Google Maps JavaScript API (Places library) only when a [data-gc-gr] block nears the viewport,
   makes ONE Place Details request per page view (fields: rating, userRatingCount, reviews, googleMapsURI,
   googleMapsLinks), renders into the theme markup, and hides the blocks silently on any failure.
   Nothing is cached or stored (Google Maps Platform terms). */
(function () {
  if (window.__gcGrInit) return; window.__gcGrInit = true;
  var els = [].slice.call(document.querySelectorAll('[data-gc-gr]')).filter(function (e) { return !e.classList.contains('is-off'); });
  if (!els.length) return;
  var key = els[0].getAttribute('data-key'), pid = els[0].getAttribute('data-place');
  var started = false, done = false, timer = null;
  function off() { done = true; clearTimeout(timer); els.forEach(function (e) { e.classList.add('is-off'); e.setAttribute('aria-hidden', 'true'); }); }
  if (!key || !pid) return off();
  function safeUrl(u) { return (typeof u === 'string' && /^https:\/\//.test(u)) ? u : null; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function stars(n, r) { n.style.setProperty('--gc-gr-r', String(Math.max(0, Math.min(5, r || 0)))); }
  function render(p) {
    if (done) return;
    var rating = typeof p.rating === 'number' ? p.rating : null, count = p.userRatingCount || 0;
    if (rating === null || !count) return off();
    done = true; clearTimeout(timer);
    var all = safeUrl(p.googleMapsLinks && p.googleMapsLinks.reviewsURI) || safeUrl(p.googleMapsURI);
    var label = 'Rated ' + rating.toFixed(1) + ' out of 5 from ' + count.toLocaleString('en-US') + ' Google reviews';
    els.forEach(function (box) {
      [].forEach.call(box.querySelectorAll('[data-gc-gr-stars]'), function (s) { stars(s, rating); });
      [].forEach.call(box.querySelectorAll('[data-gc-gr-rating]'), function (s) { s.textContent = rating.toFixed(1); s.setAttribute('aria-label', label); });
      [].forEach.call(box.querySelectorAll('[data-gc-gr-count]'), function (s) { s.textContent = count.toLocaleString('en-US') + (count === 1 ? ' Google review' : ' Google reviews'); });
      [].forEach.call(box.querySelectorAll('[data-gc-gr-all]'), function (a) { if (all) a.href = all; else a.remove(); });
      if (box.getAttribute('data-gc-gr') === 'cards') {
        var list = box.querySelector('[data-gc-gr-list]');
        var revs = (p.reviews || []).filter(function (r) { return r && r.text && String(r.text).trim(); }).slice(0, 3);
        if (!revs.length || !list) { box.classList.add('is-off'); return; }
        list.textContent = '';
        revs.forEach(function (r) {
          var a = r.authorAttribution || {}, li = el('li', 'gc-gr-card'), who = el('div', 'gc-gr-card__who');
          var photo = safeUrl(a.photoURI), prof = safeUrl(a.uri);
          if (photo) { var img = el('img'); img.src = photo; img.alt = ''; img.width = 40; img.height = 40; img.loading = 'lazy'; img.referrerPolicy = 'no-referrer'; who.appendChild(img); }
          else who.appendChild(el('span', 'gc-gr-card__ph'));
          var meta = el('div'), name = el(prof ? 'a' : 'span', 'gc-gr-card__name', a.displayName || 'Google user');
          if (prof) { name.href = prof; name.target = '_blank'; name.rel = 'noopener'; }
          meta.appendChild(name);
          if (r.relativePublishTimeDescription) meta.appendChild(el('span', 'gc-gr-card__when', r.relativePublishTimeDescription));
          who.appendChild(meta); li.appendChild(who);
          var st = el('span', 'gc-gr-stars', '★★★★★'); st.setAttribute('role', 'img'); st.setAttribute('aria-label', (r.rating || 0) + ' out of 5 stars'); stars(st, r.rating); li.appendChild(st);
          li.appendChild(el('p', 'gc-gr-card__text', String(r.text).trim()));
          var foot = el('div', 'gc-gr-card__foot'), src = safeUrl(r.googleMapsURI);
          if (src) { var l = el('a', 'link', 'Read on Google Maps'); l.href = src; l.target = '_blank'; l.rel = 'noopener'; foot.appendChild(l); }
          if (r.originalTextLanguageCode && r.textLanguageCode && r.originalTextLanguageCode !== r.textLanguageCode) foot.appendChild(el('span', 'gc-gr-card__tr', 'Translated by Google'));
          li.appendChild(foot); list.appendChild(li);
        });
      }
      box.classList.add('is-ready'); box.removeAttribute('aria-hidden');
    });
  }
  function fetchPlace() {
    google.maps.importLibrary('places').then(function (lib) {
      var place = new lib.Place({ id: pid, requestedLanguage: 'en' });
      return place.fetchFields({ fields: ['rating', 'userRatingCount', 'reviews', 'googleMapsURI', 'googleMapsLinks'] });
    }).then(function (res) { render(res.place); }).catch(off);
  }
  function start() {
    if (started) return; started = true;
    timer = setTimeout(function () { if (!done) off(); }, 15000);
    if (window.google && google.maps && google.maps.importLibrary) return fetchPlace();
    var prevAuth = window.gm_authFailure;
    window.gm_authFailure = function () { off(); if (typeof prevAuth === 'function') prevAuth(); };
    window.__gcGrReady = function () { try { fetchPlace(); } catch (e) { off(); } };
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&libraries=places&loading=async&language=en&region=US&callback=__gcGrReady';
    s.async = true; s.onerror = off;
    document.head.appendChild(s);
  }
  if (!('IntersectionObserver' in window)) return start();
  var io = new IntersectionObserver(function (entries) {
    if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
  }, { rootMargin: '400px 0px' });
  els.forEach(function (e) { io.observe(e); });
})();
